define('plugin/product/view/ProductCartListView',['require','lib/view/BaseCollectionView','plugin/product/view/ProductCartItemView'],function (require) {

    var Parent = require('lib/view/BaseCollectionView');
    var ProductCartItemView = require('plugin/product/view/ProductCartItemView');

    return Parent.extend({

        childView: ProductCartItemView,

        modelEvents: {
            'sync': 'onModelSync',
        },

        childEvents: {
            'delete': 'onDeleteLine',
            'increment': 'onIncrement',
            'decrement': 'onDecrement',
        },

        initialize: function () {
            Parent.prototype.initialize.call(this, arguments);
            this.collection = this.model.get('items');

            var model = this.model;
            //TODO throttle? Debounce?
            this.saveThrottle = _.throttle(function () {
                model.store();
            }, 300);
        },

        onModelSync: function () {
            this.collection = this.model.get('items');
            this.safeRender();
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        onDeleteLine: function (view, data) {
            this.collection.remove(data.model);
            this.model.store();
        },

        onIncrement: function (view, data) {
            data.model.set('qty', data.model.get('qty') + 1);
            this.saveThrottle();
        },

        onDecrement: function (view, data) {
            var qty = data.model.get('qty');
            data.model.set('qty', qty > 1 ? qty - 1 : 1);
            this.saveThrottle();
        }
        
        
        
    });

});
